//export type Role = 'SUPERADMIN' | 'OWNER' | 'ADMIN' | 'PROFESSIONAL' | 'STAFF' | 'PATIENT';

// export type Role =
//   | "SUPERADMIN"
//   | "OWNER"
//   | "ADMIN"
//   | "PROFESSIONAL"
//   | "RECEPTIONIST"
//   | "SECRETARY"
//   | "PATIENT";

export const PROTOCOL_STATUS = ["ACTIVE", "INACTIVE", "ARCHIVED"] as const;
export type ProtocolStatus = (typeof PROTOCOL_STATUS)[number];

export const RECOVERY_PLAN_STATUS = [
  "ACTIVE",
  "INACTIVE",
  "COMPLETED",
  "ARCHIVED",
] as const;
export type RecoveryPlanStatus = (typeof RECOVERY_PLAN_STATUS)[number];

export const EXERCISE_STATUS = ["ACTIVE", "INACTIVE", "ARCHIVED"] as const;
export type ExerciseStatus = (typeof EXERCISE_STATUS)[number];

export const SPECIALTY_STATUS = ["ACTIVE", "INACTIVE", "ARCHIVED"] as const;
export type SpecialtyStatus = (typeof SPECIALTY_STATUS)[number];

export const EXCEPTION_TYPES = [
  "HOLIDAY",
  "SICK_LEAVE",
  "PERSONAL_DAYS",
  "OTHER",
] as const;
export type ExceptionType = (typeof EXCEPTION_TYPES)[number];

export const BLOCKED_TYPES = [
  "MEETING",
  "BREAK",
  "MAINTENANCE",
  "PRIVATE_APPPOINTMENT",
  "MANUAL",
  "OTHER",
] as const;
export type BlockedSlotType = (typeof BLOCKED_TYPES)[number];

export const INVOICE_STATUS = [
  "DRAFT",
  "EMITTED",
  "PAID",
  "CANCELLED",
] as const;
export type InvoiceStatus = (typeof INVOICE_STATUS)[number];

export const VALID_TRANSITIONS = {
  DRAFT: [],
  EMITTED: ["PAID", "CANCELLED"],
  PAID: [],
  CANCELLED: [], // Una anulada es el final del camino
};

export const PAYMENT_METHODS = ["CASH", "CARD", "TRANSFER", "OTHER"] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const CALENDAR_VIEWS = ["DAY", "THREE_DAYS", "WEEK", "MONTH"] as const;
export type CalendarViews = (typeof CALENDAR_VIEWS)[number];

export const THEMES = ["light", "dark"] as const;
export type Themes = (typeof THEMES)[number];

export const PLAN_TYPES = ["FREE", "PRO", "PREMIUM", "ENTERPRISE"] as const;
export type PlanType = (typeof PLAN_TYPES)[number];

export const SYSTEM_FEATURES = [
  "CALENDAR",
  "PATIENTS",
  "INVOICING",
  "REPORTS_ADVANCED",
  "CUSTOM_BRANDING",
  "NOTIFICATIONS_EMAIL",
  "NOTIFICATIONS_WHATSAPP",
  "AI_ASSISTANT",
] as const;
export type Feature = (typeof SYSTEM_FEATURES)[number];

export const SYSTEM_LIMITS = [
  "MAX_PROS",
  "MAX_CLINICS",
  "MAX_SERVICES",
  "MAX_STORAGE_GB",
];
export type Limits = (typeof SYSTEM_LIMITS)[number];

export const SUPPORT_LEVELS = ["COMMUNITY", "STANDARD", "PRIORITY"] as const;
export type SupportLevel = (typeof SUPPORT_LEVELS)[number];

export type JsonValue =
  | string
  | number
  | boolean
  | null
  | { [key: string]: JsonValue }
  | JsonValue[];

export const SUBSCRIPTION_STATUS = [
  "NONE", // No tiene suscripción Stripe (FREE)
  "TRIALING", // Trial activo
  "TRIAL_EXPIRED", // Trial vencido
  "ACTIVE", // Suscripción activa
  "PAST_DUE", // Stripe no pudo cobrar
  "INCOMPLETE", // Stripe no pudo completar el pago inicial
  "INCOMPLETE_EXPIRED", // Stripe abandonó el intento
  "CANCELED", // Cancelada pero aún vigente hasta fin de periodo
  "EXPIRED", // Cancelada y ya vencida
] as const;
export type SubscriptionStatus = (typeof SUBSCRIPTION_STATUS)[number];

export const USAGE_LIMITS = [
  "MAX_PROS",
  "MAX_CLINICS",
  "MAX_SERVICES",
  "MAX_STORAGE_GB",
];
export type UsageLimits = (typeof USAGE_LIMITS)[number];

export const BOOKING_STATUS = [
  "PENDING",
  "CONFIRMED",
  "CANCELLED",
  "COMPLETED",
] as const;
export type BookingStatus = (typeof BOOKING_STATUS)[number];

export const CLINIC_STATUS = ["ACTIVE", "INACTIVE", "ARCHIVED"] as const;
export type ClinicStatus = (typeof CLINIC_STATUS)[number];

export const INVITATION_STATUS = [
  "PENDING",
  "ACCEPTED",
  "EXPIRED",
  "CANCELLED",
] as const;
export type InvitationStatus = (typeof INVITATION_STATUS)[number];

export const USER_STATUS = [
  "PENDING",
  "ACTIVE",
  "INACTIVE",
  "ARCHIVED",
] as const;
export type UserStatus = (typeof USER_STATUS)[number];

export const PROFESSIONAL_STATUS = ["ACTIVE", "INACTIVE", "ARCHIVED"] as const;
export type ProfessionalStatus = (typeof PROFESSIONAL_STATUS)[number];

export const SERVICE_STATUS = ["ACTIVE", "INACTIVE", "ARCHIVED"] as const;
export type ServiceStatus = (typeof SERVICE_STATUS)[number];

export const SLOT_STATUS = [
  "AVAILABLE",
  "BOOKED", // Cita ya reservada
  "BLOCKED", // Bloqueo manual (descanso, reunión)
  "PAST", // Hora ya pasó
] as const;
export type SlotStatus = (typeof SLOT_STATUS)[number];

export const GENDER_OPTIONS = ["MALE", "FEMALE", "OTHER", "UNKNOWN"] as const;
export type Gender = typeof GENDER_OPTIONS[number];

export const HELP_ARTICLE_STATUS = ["ACTIVE", "INACTIVE", "ARCHIVED"] as const;
export type HelpArticleStatus = (typeof HELP_ARTICLE_STATUS)[number];

export const HELP_SCOPES = ["PUBLIC", "PUBLIC_CLINIC", "PUBLIC_PATIENT", "TENANT", "PATIENT", "SUPERADMIN"] as const;
export type HelpScope = (typeof HELP_SCOPES)[number];
